<div class="min-h-screen flex flex-col items-center justify-center bg-gray-100 dark:bg-gray-900 p-4 sm:p-6 lg:p-8">
  <div class="text-center mb-8">
    <img src="/assets/images/om_logo_full_h.svg" alt="OrganizeMED Logo" class="mx-auto h-16 w-auto" width="300"
      height="64" priority />
    <h2 class="mt-6 text-xl  text-gray-900 dark:text-white">for Doctors</h2>
  </div>
  <div
    class="max-w-md w-full bg-white dark:bg-gray-800 p-8 rounded-lg shadow-lg space-y-6 border border-gray-200 dark:border-gray-700">
    <ng-content></ng-content>
  </div>
</div>